export default __webpack_public_path__ + "static/media/food.cb18676e.svg";